/**
 * use-media.ts — Kho tệp trên máy chủ (Cài đặt → Media).
 *
 * "Lạc" nghĩa là không bản ghi nào trong cơ sở dữ liệu trỏ tới tệp đó — xoá đi
 * không hỏng gì. Đây là phần chiếm chỗ mà trước nay không có đường dọn.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { useApiQuery } from '@/hooks/use-api'

export type LoaiTep = 'anh' | 'video' | 'pdf' | 'tai-lieu' | 'khac'

export interface TepMedia {
  khoa: string
  kho: string
  ten: string
  url: string
  kichThuoc: number
  suaLuc: string
  loai: LoaiTep
  dangDung: boolean
  dungO?: string
}

export interface ThongKeKho {
  id: string
  ten: string
  moTa: string
  soTep: number
  dungLuong: number
  soTepLac: number
  dungLuongLac: number
}

export interface KetQuaMedia {
  thongKe: ThongKeKho[]
  tong: { soTep: number; dungLuong: number; soTepLac: number; dungLuongLac: number }
  soDong: number
  tep: TepMedia[]
  catBot: boolean
}

export interface BoLocMedia {
  kho?: string
  loai?: string
  trangThai?: 'lac' | 'dung'
  tim?: string
}

export function useMedia(loc: BoLocMedia) {
  const params: Record<string, string> = {}
  if (loc.kho) params.kho = loc.kho
  if (loc.loai) params.loai = loc.loai
  if (loc.trangThai) params.trangThai = loc.trangThai
  if (loc.tim) params.tim = loc.tim
  return useApiQuery<KetQuaMedia>(['media', params], '/media', params)
}

export function useXoaTepMedia() {
  const qc = useQueryClient()
  return useMutation<{ daXoa: number; boQua: { khoa: string; vi: string }[] }, unknown, string[]>({
    mutationFn: async (khoa) => (await api.post('/media/xoa', { khoa })).data,
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['media'] }) },
  })
}

export function useDonTepLac() {
  const qc = useQueryClient()
  return useMutation<{ daXoa: number; dungLuong: number }, unknown, string | undefined>({
    mutationFn: async (kho) => (await api.post('/media/don-tep-lac', kho ? { kho } : {})).data,
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['media'] }) },
  })
}

/** 1,4 GB · 544 MB · 12 KB — đọc nhanh hơn số byte thô. */
export function coChu(byte: number): string {
  if (!byte) return '0'
  const dv = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.min(dv.length - 1, Math.floor(Math.log(byte) / Math.log(1024)))
  const v = byte / 1024 ** i
  return `${v.toLocaleString('vi-VN', { maximumFractionDigits: v >= 100 || i === 0 ? 0 : 1 })} ${dv[i]}`
}
